import { Badge } from "@workspace/web-ui/components/badge"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs"
import { useParams } from "@tanstack/react-router"
 import PageHeader from "~/features/dashboard/components/page-header"
import EmptyAppointment from "~/features/dashboard/components/empty-appointment"
import { CalendarMinus2, Clock,Calendar,Video,X,CircleCheck,Info,Circle,CircleX, UserRound, Bell } from 'lucide-react';
import { Button } from "@workspace/web-ui/components/button"
// import { BookingPage } from "./booking"
// import { FileRouteTypes } from "~/routeTree.gen"

export function UrgentCareAppointmentsPage() {
    const { tab } = useParams({ strict: false })
 
  // Mock user data
  const user = {
    first_name: "Maurice",
    last_name: "Smith",
    avatar: "",
    health_profile: { 
      weight: 185,
      target_weight: 165,
      timeframe: "3 months",
    },
  }


    return (
        <main className="flex flex-col gap-6">
            <section className="py-10 gap-y-4">
                <PageHeader title="Appointment" buttonLable="Start a treatment" username={user?.first_name} description="View and manage your appointments" />
                        <AppointmentReschedule />
 

                {/* Timeline */}
                <div className="space-y-8 ">
                    <Tabs defaultValue="upcoming" value={tab} >
                        <TabsList className="h-12 w-full justify-start gap-6 rounded-none border-b mb-3 py-0">
                            <TabsTrigger
                                value="upcoming"
                                className="h-full rounded-none border-b-2 border-transparent  px-2 py-4 text-sm data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                            >
                                Upcoming
                                <Badge className="ml-2 size-4 rounded-full bg-[#FFAB1F] p-2 justify-center items-center text-center text-xs">
                                  0  {/* {appointmentsQuery.data?.appointments?.length || 0} */}
                                </Badge>
                            </TabsTrigger>
                            <TabsTrigger
                                value="past"
                                className="h-full rounded-none border-b-2 border-transparent px-0 text-sm data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                            >
                                Past encounters
                                <Badge className="ml-2 size-4 rounded-full bg-[#FFAB1F] p-2 justify-center items-center text-center text-xs">
                                      0  {/* {appointmentsPastQuery.data?.appointments?.length || 0} */}
                                </Badge>
                            </TabsTrigger>
                        </TabsList>

                        <TabsContent value="upcoming" className="flex gap-4 w-full">
                            <UpcomingAppointments />
                            {/* <EmptyAppointment description="Once you book an appointment, it will appear here for easy access. If you have any concerns or need assistance, please contact support." /> */}
                            {/* {appointmentsQuery.data?.appointments && appointmentsQuery.data?.appointments?.length > 0 ? <AppointmentUi appointments={appointmentsQuery.data?.appointments} /> : <EmptyAppointment timeline="upcoming" />} */}
                        </TabsContent>

                        <TabsContent value="past" className="flex gap-4">
                            <EmptyAppointment description="You currently do not have any past appointments. Once you book and join appointment, they will appear here. If you have any concerns or need assistance, please contact support." />
                            {/* {appointmentsPastQuery.data?.appointments && appointmentsPastQuery.data?.appointments?.length > 0 ? <AppointmentUi appointments={appointmentsPastQuery.data?.appointments} /> : <EmptyAppointment timeline="past" />} */}
                        </TabsContent>
                    </Tabs>
                </div>
            </section>
        </main>
    )
}
const UpcomingAppointments = () => {
    return (
        <div className="flex flex-col gap-4">
            <div className="w-full grid lg:grid-cols-2 grid-cols-1 gap-6">
                <div className="flex flex-col gap-[16px] w-full">
                    {Array.from({ length: 3 }).map((_, index) => (
                        <AppointmentsCard key={index} />
                    ))}
                </div>
                 <AppointmentsDetails />
            </div>
        </div>
    )
}
const AppointmentsCard = () => {
    return (
        <div role="button" className="border rounded-[12px] hover:border-[#04040466] border-[#0404041A] lg:p-[20px] p-[16px] flex flex-col gap-[8px] ">
            <div className="flex items-center gap-2">
               <h1 className="text-[#1A202C] text-[18px] font-medium leading-[130%] tracking-[-1%]">Herpes Urgent care appointment</h1>
            </div>
            <div className="flex w-full items-center gap-4">
                <div className="flex items-center gap-2 text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
                    <CalendarMinus2 className="w-4 h-4" />
                    Apr 5, 2025
                </div>
                <div className="flex items-center gap-2 text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
                    <Clock className="w-4 h-4" />
                    10:00 AM
                </div>
            </div>
            <div className="flex flex-wrap items-center gap-[8px]">
                <AppointmentTimeTag time="10:00 AM"  />
                <AppointmentStatusTag type="completed" />
                <AppointmentStatusTag type="missed" />
            </div>
        </div>
    )
}
const AppointmentsDetails = () => {
    return (
        <div className="border rounded-[12px] border-[#04040466] py-[20px] ">
            <div className="flex flex-col  gap-[16px] lg:px-[20px] px-[16px]">
                <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center gap-[8px]">
                <h1 className="text-[#1A202C] text-[20px] font-medium leading-[130%] tracking-[-2%]">Asthma / Asthma Exacerbation</h1>
                <div className="w-full lg:w-[40%] flex flex-row lg:justify-end justify-start items-center gap-2"> 
                  <AppointmentTimeTag time="10:00 AM"  />
                  </div>
                </div>
                <div className="flex gap-[12px] flex-col">
                    <div className="flex flex-col justify-between gap-[8px]">
                        <div className="flex flex-row gap-[16px]">
                            <CalendarMinus2 className="w-4 h-4 mt-1 text-[#6C757D]" />
                            <div className="flex flex-col gap-[4px]">
                                <h1 className="text-[#1A202C] text-[14px] leading-[140%] font-medium tracking-[-1%]">Date</h1>                           
                                <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Wednesday, March 26, 2025</span>
                            </div>                       
                        </div>
                        <div className="flex flex-row gap-[16px]">
                            <Clock className="w-4 h-4 mt-1 text-[#6C757D]" />
                            <div className="flex flex-col gap-[4px]">
                                <h1 className="text-[#1A202C] text-[14px] leading-[140%] font-medium tracking-[-1%]">Time</h1>                           
                                <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">10:30 AM</span>
                            </div>                       
                        </div>
                        <div className="flex flex-row gap-[16px]">
                            <Video className="w-4 h-4 mt-1 text-[#6C757D]" />
                            <div className="flex flex-col gap-[4px]">
                                <h1 className="text-[#1A202C] text-[14px] leading-[140%] font-medium tracking-[-1%]">Location</h1>                           
                                <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Zoom </span>
                            </div>                       
                        </div>

                    </div>
                </div>
                <div className="flex flex-row gap-[8px] items-center bg-[#E6FAF2] rounded-[8px] p-[12px]"><Info className="w-4 h-4 text-[#00C781]" /> <span className="text-[#003D26] text-[14px] leading-[140%] font-medium tracking-[-1%]">You attended this appointment</span></div>
                <div className="flex flex-col gap-[16px] bg-[#F1F4F9] rounded-[8px] lg:p-[16px] p-[12px]">                    
                    <h1 className="text-[#1A202C] text-[18px] leading-[130%] font-medium tracking-[-1%]">Recommended task</h1>
                    <div className="bg-[#FFFFFF] border-[#E6E6E6] border-[1px] px-[12px] py-[8px] rounded-[12px] flex lg:flex-row flex-col gap-[8px] lg:justify-between lg:items-center">
                        <div className="flex flex-row gap-[8px] py-[12px] items-center">
                            <Circle className="w-4 h-4 text-[#00C781]" />                   
                         <span className="text-[#003D26] text-[14px] leading-[140%] font-medium tracking-[-1%]">Pay for medication</span>
                    </div>
                     <Button  className="border-[#DCDCDE] h-auto lg:w-fit w-full text-[#FFFFFF] !py-[12px] !px-[16px] rounded-[10px]">
                        Pay now           
                    </Button>

                    </div>
                </div>
                <div className="flex flex-row w-full gap-[12px]">
              <Button variant="outline"  className="border-[#DCDEE3] h-auto w-full text-[#464B55] !py-[12px] !px-[16px] rounded-[10px]">
                Reschedule            
            </Button> 
              <Button  className="border-[#DCDCDE] h-auto w-full text-[#FFFFFF] !py-[12px] !px-[16px] rounded-[10px]">
            Join meeting           
            </Button>

                </div>
                <div className="bg-[#F1F4F9] rounded-[16px] p-[16px] flex flex-col gap-[16px]">
                    <h1 className="text-[#1A202C] text-[18px] leading-[130%] font-medium tracking-[-1%]">What to do</h1>

                    <div className="flex flex-col gap-[8px]">
                         <p className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]"> This appointment will be conducted via video call. Please ensure you have:</p>
                        {/* <p className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Review any provided materials and come prepared with questions or topics to discuss.</p>
                        <p className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Click the meeting link at the scheduled time.</p> */}
                                            <ol className="list-decimal list-inside flex flex-col gap-[8px] mt-2">
                                                <li className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
                                                    Review any provided materials and come prepared with questions or topics to discuss.
                                                </li>
                                                <li className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
                                                    Click the meeting link at the scheduled time.
                                                </li>
                                            </ol>
                        <span className="text-[#1A202C] text-[14px] leading-[140%] font-medium tracking-[-1%]">Contact Support: Need help? Reach out to our support team appointments@proxymedicine.com</span>
                        </div>
                    </div>

             </div>
         </div>
    )
}
const AppointmentTimeTag = ({time}:{time:string}) => {
    const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return (
        <div className="flex items-center gap-2 bg-[#FFF6E7] text-[#FFA726] py-[3px] px-[10px] rounded-full text-[14px] leading-[140%] font-normal tracking-[-1%]">
             {time === currentTime && <Video className="w-4 h-4" />}
            {time !== currentTime && <Calendar className="w-4 h-4" />}
            {time === currentTime ?'Happening now' : time}
        </div>
    )
}
const AppointmentStatusTag = ({type}:{type:string}) => {
    const tagStyles = {
         "completed":  "text-[#00C781] bg-[#E6FAF2]",
        "missed": "text-[#7F8493] bg-[#7F849326]"
    }[type] || "";

    return (
        <span className={`${tagStyles} text-[14px] w-fit leading-[140%] font-medium flex items-center gap-[2px] py-[2px] px-[5px] rounded-full tracking-[-1%]`}>
             {type === "completed" && <CircleCheck className="size-4" />}
            {type === "missed" && <X className="size-4" />}
            {type.charAt(0).toUpperCase() + type.slice(1).replace(/_/g, ' ')}
        </span>
    )
}
const AppointmentReschedule = () => {
    return (
        <div className="flex flex-col gap-[32px] hidden">
            <div className="flex justify-end w-full"><button><CircleX className="w-8 h-8 text-[#7F8493]" /></button></div>
            <h1 className="text-[#2D2F35] text-[32px] leading-[140%] font-medium tracking-[-2%] text-center">Reschedule appointment</h1>
            <div className="grid grid-cols-6 py-[16px] gap-[16px]">
                <div style={{boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05)"}} className="flex flex-col col-span-2 gap-[16px] border-[#E6E6E6] border-[1px] rounded-[16px] py-[16px]">
                    <div className="border-b border-[#E6E6E6] pb-[16px]">
                        <h1 className="text-[#1A202C] text-[20px] leading-[150%] font-medium tracking-[-2%] text-center px-[20px]">Weight loss consultation</h1>
                    </div> 
                    <div className="border-b border-[#E6E6E6] pb-[16px]">
                        <p className="text-[#2D2F35] text-[18px] leading-[130%] font-medium tracking-[-2%] text-center px-[20px]">Current Booking Details</p>
                    </div> 

                    <div className="flex flex-col gap-[16px]">
                        <div className="flex gap-[8px] px-[20px] items-center">
                            <UserRound className="w-6 h-6 text-[#7F8493]" /> 
                           <span className="text-[#26282F] text-[16px] leading-[150%] font-normal tracking-[0%]">Maurice Umoh</span>
                        </div>                        
                        <div className="flex gap-[8px] px-[20px] items-center">
                            <Calendar className="w-6 h-6 text-[#7F8493]" /> 
                           <span className="text-[#26282F] text-[16px] leading-[150%] font-normal tracking-[0%]">Wednesday, March 26, 2025</span>
                        </div>                        
                        <div className="flex gap-[8px] px-[20px] items-center">
                            <Bell className="w-6 h-6 text-[#7F8493]" /> 
                           <span className="text-[#26282F] text-[16px] leading-[150%] font-normal tracking-[0%]">12:00 AM, West africa</span>
                        </div>
                        <div className="flex gap-[8px] px-[20px] items-center">
                            <Clock className="w-6 h-6 text-[#7F8493]" /> 
                           <span className="text-[#26282F] text-[16px] leading-[150%] font-normal tracking-[0%]">60 minutes</span>
                        </div>                        
                      
                    </div>
               </div>
                <div  style={{boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05)"}}  className="col-span-4 border-[#E6E6E6] border-[1px] rounded-[16px] p-[16px]">k</div>
            </div>
        </div>
    )
}